import React from "react";

const Footer = ({ menuIsOpen }) => {
  return (
    <div className={menuIsOpen ? "footer-div footer-div-menu" : "footer-div"}>
      <a href="tel:+32 472 46 40 59" id="tel-link" aria-label="telefoon">
        <svg
          id="phone-icon"
          className={menuIsOpen ? "phone-footer-icon" : null}
          data-name="Laag 1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 749.79 800.73"
        >
          <path
            class="cls-1"
            d="M783,797.91c-5.79.53-11.57-.13-17.3-.55a283.53,283.53,0,0,1-58-10.39,362.61,362.61,0,0,1-41.23-14.78c-9.35-4-18.5-8.38-27.46-13.12q-19-10.05-37-21.85-16.4-10.72-32-22.55c-7-5.31-13.86-10.88-20.64-16.52-8.88-7.39-17.62-14.94-26.12-22.77q-6.88-6.35-13.72-12.74c-7.15-6.71-14.13-13.6-21-20.6q-9.42-9.63-18.56-19.52c-5.74-6.21-11.42-12.48-16.94-18.89-7.89-9.16-15.76-18.33-23.45-27.66q-18.17-22-35-45.11Q374.54,503.31,357,474.07q-13.87-23.2-25.44-47.62a428.71,428.71,0,0,1-18.93-46.52c-4-11.82-7.61-23.75-10.43-35.9-2.08-8.92-3.89-17.9-5.09-27-1-7.24-1.78-14.48-2.41-21.76a225.82,225.82,0,0,1-.8-29.3c.33-7.37.87-14.75,1.74-22.11a249.4,249.4,0,0,1,6-32.63,237.28,237.28,0,0,1,12.42-36,225.21,225.21,0,0,1,18-33.4,230.24,230.24,0,0,1,14.68-19.87,240.73,240.73,0,0,1,19-20.34,215.08,215.08,0,0,1,18.81-15.8c3.09-2.37,5.94-5,8.89-7.6,8.24-7.13,15.94-14.94,25-21,7.54-5,15.7-8.71,25-9.59,10.29-1,19.49,1.72,28.37,6.67,9.13,5.1,16.77,12,23.66,19.6,11.17,12.38,20.67,26,29.39,40.25,5.92,9.64,12.32,19,18.26,28.6,7.11,11.53,13.77,23.3,19.07,35.83a137.87,137.87,0,0,1,8.77,28,108.39,108.39,0,0,1,1.21,11.14,64.21,64.21,0,0,1-2.1,21.89,69.33,69.33,0,0,1-12.67,25c-6.68,8.59-15.22,15.17-23.27,22.3-6,5.28-11.8,10.73-18.12,15.57-4.83,3.7-10.06,6.87-15,10.49-11.22,8.28-19.87,18.51-23.41,32.34a63.47,63.47,0,0,0-1.35,22,105.53,105.53,0,0,0,6,25.56,199,199,0,0,0,14.29,30.49c5.25,9.33,11,18.32,17,27.12,6.69,9.72,13.83,19.11,21.17,28.36,6.61,8.35,13.49,16.47,20.38,24.58,4.7,5.54,9.83,10.71,14.62,16.18,5.76,6.59,11.9,12.79,18,19A401.72,401.72,0,0,0,623,570.4a208.4,208.4,0,0,0,35.45,23.32,94,94,0,0,0,25.17,8.93c17.41,3.26,33.2-.32,47.07-11.78,7.38-6.1,13.22-13.65,20.12-20.18,6.25-5.92,12.81-11.48,19.39-17,3.78-3.18,7.41-6.53,11.21-9.69a76.39,76.39,0,0,1,23-13.6,70.41,70.41,0,0,1,19.69-4c11.64-.68,22.64,1.78,33.36,5.88a148.88,148.88,0,0,1,32.06,17.44q10.32,7.23,20,15.32c7.93,6.64,15.72,13.46,23.56,20.21,6.71,5.77,13.4,11.54,20,17.49,11.22,10.17,21.55,21.1,29.79,33.84,5.42,8.36,9.44,17.46,10.48,27.48s-1.47,19.25-6.61,27.83a66.69,66.69,0,0,1-11.81,14.61c-5.95,5.53-12.24,10.69-18.35,16.05-3.24,2.84-6.54,5.62-9.6,8.65a228.05,228.05,0,0,1-93.64,56.36,213.39,213.39,0,0,1-33.45,7.59c-8.36,1.17-16.71,2.06-25.15,2.5C790.8,797.79,786.88,797.69,783,797.91Z"
            transform="translate(-268.76 -22.38)"
          />
        </svg>
      </a>
      <a href="mailto:lauren.maenen@gmail.com" aria-label="e-mail">
        <svg
          version="1.1"
          id="mail-icon"
          className={menuIsOpen ? "menu-footer-icon" : null}
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 512 512"
        >
          <g id="mail-icon-path">
            <g>
              <path
                className="st0"
                d="M467,80.6H45c-24.8,0-45,20.2-45,45v260.8c0,24.8,20.2,45,45,45h422c24.8,0,45-20.2,45-45V125.6
			C512,100.8,491.8,80.6,467,80.6z M461.1,110.6l-6,5L273.9,266.6c-10.3,8.6-25.4,8.6-35.7,0L56.9,115.6l-6-5H461.1z M30,132.3
			l147.7,123L30,353.5V132.3z M467,401.4H45c-7.2,0-13.3-5.2-14.7-12l171.4-114.1l17.2,14.3c10.7,8.9,23.9,13.4,37.1,13.4
			c13.2,0,26.3-4.5,37.1-13.4l17.2-14.3l171.4,114.1C480.3,396.2,474.2,401.4,467,401.4z M482,353.5l-147.7-98.3l147.7-123V353.5z"
              />
            </g>
          </g>
        </svg>
      </a>
      <a
        href="https://www.instagram.com/psychologelauren/"
        id="insta-link"
        target="_blank"
        rel="noreferrer"
        aria-label="Instagram"
      >
        <svg
          version="1.1"
          id="instagram-icon"
          className={menuIsOpen ? "menu-footer-icon" : null}
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 511 511"
        >
          <path
            className="st0"
            d="M510.5,150.2c-1.2-27.2-5.6-45.8-11.9-62c-6.5-17.2-16.5-32.5-29.5-45.3c-12.8-13-28.3-23.1-45.2-29.4
	c-16.3-6.3-34.8-10.7-62-11.9C334.5,0.3,325.8,0,256.4,0s-78.1,0.3-105.3,1.5c-27.2,1.2-45.8,5.6-62,11.9
	C72,19.9,56.6,29.8,43.8,42.9c-13,12.8-23.1,28.3-29.4,45.2c-6.3,16.3-10.7,34.8-11.9,62c-1.3,27.4-1.6,36-1.6,105.4
	s0.3,78.1,1.5,105.3c1.2,27.2,5.6,45.8,11.9,62c6.5,17.2,16.6,32.5,29.5,45.3c12.8,13,28.3,23.1,45.2,29.4
	c16.3,6.3,34.8,10.7,62,11.9c27.2,1.2,35.9,1.5,105.3,1.5s78.1-0.3,105.3-1.5c27.2-1.2,45.8-5.6,62-11.9
	c34.3-13.3,61.5-40.4,74.8-74.8c6.3-16.3,10.7-34.8,11.9-62c1.2-27.3,1.5-35.9,1.5-105.3S511.7,177.5,510.5,150.2z M464.5,358.9
	c-1.1,25-5.3,38.4-8.8,47.4c-8.6,22.3-26.3,39.9-48.5,48.5c-9,3.5-22.6,7.7-47.4,8.8c-27,1.2-35,1.5-103.2,1.5s-76.4-0.3-103.2-1.5
	c-25-1.1-38.4-5.3-47.4-8.8c-11.1-4.1-21.2-10.6-29.3-19.1c-8.5-8.3-15-18.3-19.1-29.3c-3.5-9-7.7-22.6-8.8-47.4
	c-1.2-27-1.5-35-1.5-103.2s0.3-76.4,1.5-103.2c1.1-25,5.3-38.4,8.8-47.4C61.6,94,68.1,84,76.7,75.8c8.3-8.5,18.3-15,29.3-19.1
	c9-3.5,22.6-7.7,47.4-8.8c27-1.2,35-1.5,103.2-1.5c68.3,0,76.4,0.3,103.2,1.5c25,1.1,38.4,5.3,47.4,8.8
	c11.1,4.1,21.2,10.6,29.3,19.1c8.5,8.3,15,18.3,19.1,29.4c3.5,9,7.7,22.6,8.8,47.4c1.2,27,1.5,35,1.5,103.2S465.7,331.9,464.5,358.9
	z"
          />
          <path
            className="st0"
            d="M256.4,124.3c-72.5,0-131.3,58.8-131.3,131.3S184,386.8,256.4,386.8c72.5,0,131.3-58.8,131.3-131.3
	S328.9,124.3,256.4,124.3z M256.4,340.7c-47,0-85.2-38.1-85.2-85.2s38.1-85.2,85.2-85.2c47,0,85.2,38.1,85.2,85.2
	S303.5,340.7,256.4,340.7z"
          />
          <path
            className="st0"
            d="M423.6,119.1c0,16.9-13.7,30.6-30.6,30.6c-16.9,0-30.6-13.7-30.6-30.6c0-16.9,13.7-30.6,30.6-30.6
	C409.8,88.4,423.6,102.2,423.6,119.1z"
          />
        </svg>
      </a>
    </div>
  );
};

export default Footer;
